// src/pages/auth/LoginPage/components/ForgotPasswordForm/ForgotPasswordForm.js
import React, { useState } from 'react';
import { strapiAuthService } from '../../../../../services/api/strapiAuth';
import './ForgotPasswordForm.scss';
import { validateField } from '../../../../../services/inputCheck';

const ForgotPasswordForm = ({ onBackToLogin }) => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({
        email: '',
        general: ''
    });
    const [success, setSuccess] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEmail(value);

        // Validation en temps réel
        const error = validateField(name, value);
        setErrors(prev => ({
            ...prev,
            [name]: error,
            general: '' // Réinitialiser l'erreur générale
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrors({
            email: '',
            general: ''
        });
        setSuccess(false);

        // Validation des champs
        const emailError = validateField('email', email);
    
        if (emailError) {
            setErrors({
                email: emailError,
                general: ''
            });
            setLoading(false);
            return;
        }

        try {
            await strapiAuthService.forgotPassword(email);
            setSuccess(true);
        } catch (err) {
            console.error('Erreur mot de passe oublié:', err);
            
            // Gestion des erreurs Strapi
            const errorMessage = err.message.toLowerCase();
            
            if (errorMessage.includes('user not found') || 
                errorMessage.includes('utilisateur non trouvé') ||
                errorMessage.includes('this email does not exist')) {
                setErrors(prev => ({
                    ...prev,
                    email: 'Aucun compte n\'existe avec cet email'
                }));
            } else {
                setErrors(prev => ({
                    ...prev,
                    general: err.message || 'Une erreur est survenue lors de l\'envoi de l\'email'
                }));
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="forgot-password-form__container">
            <h1>Mot de passe oublié ?</h1>
            
            {success ? (
                <div className="forgot-password-form__success">
                    <div className="success_text">
                        <p>Un email a été envoyé à l'adresse <b>{email}</b>.</p>
                        <p>Vérifie ta boîte de réception et suis les instructions.</p>
                        <p className='italic'>N'oublie pas de regarder dans les courriers indésirables.</p>
                    </div>
                    <button
                        onClick={onBackToLogin}
                        className="forgot-password-form__back-link"
                    >
                        Retour à la connexion
                    </button>
                </div>
            ) : (
                <>
                    <p className="forgot-password-form__description">
                        Entre ton adresse e-mail ci-dessous. Nous t'enverrons un lien pour réinitialiser ton mot de passe.
                    </p>
                    <form className="forgot-password-form" onSubmit={handleSubmit}>
                        <div className="forgot-password-form__input-group">
                            <label htmlFor="email">Email</label>
                            <input
                                id="email"
                                type="email"
                                name="email"
                                value={email}
                                onChange={handleChange}
                                className={errors.email ? 'error' : ''}
                                required
                                placeholder="Ton adresse email"
                            />
                            {errors.email && (
                                <span className="forgot-password-form__error-message">
                                    {errors.email}
                                </span>
                            )}
                        </div>

                        {errors.general && (
                            <div className="forgot-password-form__error">
                                {errors.general}
                            </div>
                        )}

                        <button
                            type="submit"
                            className="forgot-password-form__submit"
                            disabled={loading || Object.values(errors).some(error => error)}
                        >
                            {loading ? 'Envoi en cours...' : 'Envoyer le lien'}
                        </button>

                        <div className="forgot-password-form__footer">
                            <button
                                type="button"
                                onClick={() => {
                                    setEmail('');
                                    onBackToLogin();
                                }}
                                className="forgot-password-form__back-link"
                            >
                                Retour à la connexion
                            </button>
                        </div>
                    </form>
                </>
            )}
        </div>
    );
};

export default ForgotPasswordForm;